<template>
  <div>
    <confirmation-dialog ref="confirm" />
    <router-view />
  </div>
</template>

<script>
import { ConfirmationDialog } from "@/app/shared/components";

export default {
  name: "app",
  components: {
    ConfirmationDialog
  },
  mounted() {
    this.$root.$confirm = this.$refs.confirm.open;
  }
};
</script>

<style></style>
